import * as echarts from 'echarts';

//柱状图
const bar_chart = (id, xData, yData, seriesData,title)=>{
    let bar = echarts.init(document.getElementById(id));
    bar.setOption({
      title:{
        text:title,
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {type: 'shadow'}
      },
      xAxis: [{
        type : 'category',
        data : xData,
        axisTick: {alignWithLabel: true},
        splitLine:{
            show:false
        },
        axisLabel:{
          color: () => "#D3D3D3"
        },
        axisLine:{
          lineStyle:{
            color:"#D3D3D3",
          }
        },
      }],
      yAxis: {
        type: 'value',
        axisLabel:{
          color: () => "#D3D3D3"
        },
        axisLine:{
          lineStyle:{
            color:"#D3D3D3",
          }
        }
      },
      series: [
        {
          data: seriesData,
          type: 'bar',
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: '#83bff6' },
              { offset: 0.5, color: '#188df0' },
              { offset: 1, color: '#188df0' }
            ])
          },
          emphasis: {
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#2378f7' },
                { offset: 0.7, color: '#2378f7' },
                { offset: 1, color: '#83bff6' }
              ])
            }
          },
        }
      ]
    });
}


//饼状图
const pie_chart = (title,id,seriesData) => {
    let pie = echarts.init(document.getElementById(id));
    pie.setOption({
        title:{
            text:title,
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          top: 'bottom',
          left: 'center',
          textStyle:{
            color:"#000"
          }
        },
        series: [
          {
            name: title,
            type: 'pie',
            radius: '60%',
            data: seriesData,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
    })
}


export default {
    bar_chart,
    pie_chart
}


// WEBPACK FOOTER //
// ./src/util/myecharts.js